"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var contextProperty_1 = require("owa-service/lib/factory/contextProperty");
var findPeopleJsonRequest_1 = require("owa-service/lib/factory/findPeopleJsonRequest");
var findPeopleRequest_1 = require("owa-service/lib/factory/findPeopleRequest");
var folderId_1 = require("owa-service/lib/factory/folderId");
var indexedPageView_1 = require("owa-service/lib/factory/indexedPageView");
var personaResponseShape_1 = require("owa-service/lib/factory/personaResponseShape");
var propertyUri_1 = require("owa-service/lib/factory/propertyUri");
var sortResults_1 = require("owa-service/lib/factory/sortResults");
var targetFolderId_1 = require("owa-service/lib/factory/targetFolderId");
var findPeopleOperation_1 = require("owa-service/lib/operation/findPeopleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var MAX_ENTRIES_DEFAULT = 50;
var OFFSET_DEFAULT = 0;
function configureIndexedPageView(offset, maxEntries) {
    return indexedPageView_1.default({
        BasePoint: 'Beginning',
        Offset: offset ? offset : OFFSET_DEFAULT,
        MaxEntriesReturned: maxEntries ? maxEntries : MAX_ENTRIES_DEFAULT,
    });
}
function configureParentFolderId() {
    return targetFolderId_1.default({
        BaseFolderId: folderId_1.default({
            Id: folderNameToId_1.default('contacts'),
        }),
    });
}
function configureSortOrder() {
    var primarySort = sortResults_1.default({
        Order: 'Ascending',
        Path: propertyUri_1.default({ FieldURI: 'PersonaDisplayNameFirstLast' }),
    });
    return [primarySort];
}
function configurePersonaShape() {
    return owa_mail_feature_flags_1.isMailFeatureEnabled('rp-requestPersonaResponseShape')
        ? personaResponseShape_1.default({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri_1.default({ FieldURI: 'PersonaEmailAddress' }),
                propertyUri_1.default({ FieldURI: 'EmailAddresses' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayName' }),
                propertyUri_1.default({ FieldURI: 'PersonaDisplayNames' }),
                propertyUri_1.default({ FieldURI: 'PersonaId' }),
                propertyUri_1.default({ FieldURI: 'PersonaType' }),
            ],
        })
        : personaResponseShape_1.default({
            BaseShape: 'Default',
        });
}
function configureRequestBody(offset, maxEntries) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: configureIndexedPageView(offset, maxEntries),
        ParentFolderId: configureParentFolderId(),
        PersonaShape: configurePersonaShape(),
        QueryString: null,
        SearchPeopleSuggestionIndex: false,
        ShouldResolveOneOffEmailAddress: false,
        SortOrder: configureSortOrder(),
        Context: configureContext(),
    });
}
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
function findPeople(offset, maxEntries) {
    var requestBody = configureRequestBody(offset, maxEntries);
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    })).then(function (response) {
        var responseMessage = response.Body;
        return responseMessage;
    });
}
exports.findPeople = findPeople;
//# sourceMappingURL=findPeople.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-contact-picker/lib/services/findPeople.js
// module id = 5206
// module chunks = 99